import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  ADD_BUNDLE_TO_CART,
  ADD_PET_TO_CART,
  ADD_SERVICE_TO_CART,
  APPLY_COUPON_CODE,
  APPLY_REWARD_POINTS,
  APPLY_WALLET,
  CREATE_CART,
  DELETE_CART,
  GET_CART,
  GET_CHECKOUT_SUMMARY,
  GET_CUSTOMER_ORDER_DETAILS,
  GET_CUSTOMER_ORDERS,
  GET_USER_CART,
  GET_WALLETS_TOP_UP,
  GetProductsBycategory,
  PAYMENT_INITIATE,
  PAYMENT_STATUS,
  PAYMENT_SUCCESS_DETAILS,
  PET_CART_MODIFICATION,
  PROCESS_TO_CHECKOUT,
  PRODUCT_CART_MODIFICATION,
  REMOVE_COUPON_CODE,
  REMOVE_FREE_GIFT,
  REMOVE_PET_TO_CART,
  REMOVE_REWARD_POINTS,
  REMOVE_SERVICE_TO_CART,
  REMOVE_WALLET,
  RETRY_PAYMENT,
  SELECT_ADDRESS,
  SELECT_FREE_GIFT,
  SERVICE_CART_MODIFICATION,
  UPDATE_CART_ITEM,
  UPDATE_CART_SUBSCRIPTION,
  UPDATE_DONATION,
  UPDATE_PET_PURCHASE_TYPE,
  UPDATE_REVISION,
  WALLET_PAYMENT,
  WALLETS_TOP_UP,
} from "../../../config/apiUrlsCustomer";
import {
  AddBundleToCartRequest,
  AddressRequest,
  AddServiceToCart,
  ApplyCouponRequest,
  ApplyRewardPointsRequest,
  ApplyWalletRequest,
  ClaimGiftRequest,
  DonationRequest,
  IAddPetToCartRequest,
  IAddTopUpWalletRequest,
  ICartRequest,
  ICustomerRateOrderItemRequest,
  ICustomerRateOrderRequest,
  IGetCustomerOrdersRequest,
  IGetProductsByCategoryRequest,
  IRetryRevisionRequest,
  ISubmitReviewRequest,
  IUpdateCartItemRequest,
  IUpdateCartSubscriptionRequest,
  IUpdatePetPurchaseTypeRequest,
  PaymentInitiateRequest,
  PaymentResult,
  PaymentResultResponse,
  ProcessToCheckoutRequest,
} from "../../../types/Request/CustomerRequest";
import {
  CheckoutSummaryResponseDto,
  CompleteInternalPaymentResponse,
  CreateOrderResponse,
  CreatePaymentSessionResponse,
  IBundleCartResponse,
  ICartResponse,
  ICheckoutSummaryResponse,
  ICustomerRatingResponse,
  IDeleteCartResponse,
  IGetCartResponse,
  IGetCustomerOrderDetailsResponse,
  IGetCustomerOrdersResponse,
  IGetProductsByCategoryResponse,
  IgetUserCartResponse,
  IWalletPaymentResponse,
  IWalletTopupPackagesResponse,
  PaymentSessionResponse,
  PaymentStatusResponse,
} from "../../../types/Response/CustomerResponse";

export const customerCartAPi = createApi({
  reducerPath: "customerCartAPi",
  baseQuery: axiosBaseQuery(),

  tagTypes: ["Cart"],

  endpoints: (builder) => ({
    createCart: builder.mutation<ICartResponse, ICartRequest>({
      query: (data) => ({
        url: `${CREATE_CART}`,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Cart"],
    }),
    getCart: builder.query<IGetCartResponse, void>({
      query: () => ({
        url: `${GET_CART}`,
        method: "get",
      }),
      providesTags: ["Cart"],
    }),
    updateCart: builder.mutation<IGetCartResponse, IUpdateCartItemRequest>({
      query: (data) => ({
        url: `${UPDATE_CART_ITEM}`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Cart"],
    }),
    deleteCart: builder.query<IDeleteCartResponse, number>({
      query: (cartItemId) => ({
        url: `${DELETE_CART}/${cartItemId}`,
        method: "delete",
      }),
    }),
    getUserCart: builder.query<IgetUserCartResponse, void>({
      query: () => ({
        url: `${GET_USER_CART}`,
        method: "get",
      }),
      providesTags: ["Cart"],
    }),

    getCheckoutSummary: builder.query<CheckoutSummaryResponseDto, void>({
      query: () => ({
        url: GET_CHECKOUT_SUMMARY,
        method: "get",
      }),
    }),

    /////  pet cart ////

    AddPetTocart: builder.mutation<Boolean, IAddPetToCartRequest>({
      query: (data) => ({
        url: `${ADD_PET_TO_CART}`,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Cart"],
    }),
    RemoveTocart: builder.query<Boolean, number>({
      query: (id) => ({
        url: `${REMOVE_PET_TO_CART}/${id}`,
        method: "delete",
      }),
    }),
    ///// SERVICE ///
    RemoveServiceTocart: builder.query<Boolean, number>({
      query: (id) => ({
        url: `${REMOVE_SERVICE_TO_CART}/${id}`,
        method: "delete",
      }),
    }),

    AddServiceToCart: builder.mutation<Boolean, AddServiceToCart>({
      query: (data) => ({
        url: ADD_SERVICE_TO_CART,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Cart"],
    }),

    ////////  ADDD BUNDEL TO CART ////

    AddBundleToCart: builder.mutation<
      IBundleCartResponse,
      AddBundleToCartRequest
    >({
      query: (data) => ({
        url: `${ADD_BUNDLE_TO_CART}`,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Cart"],
    }),

    removeBundleFromCart: builder.query<IBundleCartResponse, number>({
      query: (BundleId) => ({
        url: `${ADD_BUNDLE_TO_CART}/${BundleId}`,
        method: "delete",
      }),
    }),

    //// COUPON ////
    applyCoupon: builder.mutation<
      CheckoutSummaryResponseDto,
      ApplyCouponRequest
    >({
      query: (data) => ({
        url: APPLY_COUPON_CODE,
        method: "post",
        data: data,
      }),
    }),

    applyRewardPoints: builder.mutation<
      CheckoutSummaryResponseDto,
      ApplyRewardPointsRequest
    >({
      query: (data) => ({
        url: APPLY_REWARD_POINTS,
        method: "post",
        data: data,
      }),
    }),

    applyWallet: builder.mutation<
      CheckoutSummaryResponseDto,
      ApplyWalletRequest
    >({
      query: (data) => ({
        url: APPLY_WALLET,
        method: "post",
        data: data,
      }),
    }),
    RemoveWallet: builder.query<CheckoutSummaryResponseDto, void>({
      query: () => ({
        url: REMOVE_WALLET,
        method: "delete",
      }),
    }),
    SelectFreeGift: builder.mutation<
      CheckoutSummaryResponseDto,
      ClaimGiftRequest
    >({
      query: (data) => ({
        url: SELECT_FREE_GIFT,
        method: "post",
        data: data,
      }),
    }),

    UpdateDonation: builder.mutation<
      CheckoutSummaryResponseDto,
      DonationRequest
    >({
      query: (data) => ({
        url: UPDATE_DONATION,
        method: "post",
        data: data,
      }),
    }),

    removeCoupon: builder.query<CheckoutSummaryResponseDto, void>({
      query: () => ({
        url: REMOVE_COUPON_CODE,
        method: "delete",
      }),
    }),

    removeRewardPoints: builder.query<CheckoutSummaryResponseDto, void>({
      query: () => ({
        url: REMOVE_REWARD_POINTS,
        method: "delete",
      }),
    }),
    removeFreeGift: builder.query<CheckoutSummaryResponseDto, void>({
      query: () => ({
        url: REMOVE_FREE_GIFT,
        method: "delete",
      }),
    }),

    SelectAddress: builder.mutation<CheckoutSummaryResponseDto, AddressRequest>(
      {
        query: (data) => ({
          url: SELECT_ADDRESS,
          method: "post",
          data: data,
        }),
      },
    ),
    ProcessToCheckout: builder.mutation<
      CreateOrderResponse,
      ProcessToCheckoutRequest
    >({
      query: (data) => ({
        url: PROCESS_TO_CHECKOUT,
        method: "post",
        data: data,
      }),
    }),

    updateCartSubscription: builder.mutation<
    IGetCartResponse,
    {cartItemId:number ,data:  IUpdateCartSubscriptionRequest}
  
>({
    query: ({cartItemId,data}) => ({
        url: `${UPDATE_CART_SUBSCRIPTION}/${cartItemId}/subscription`,
        method: "patch",
        data: data,
      invalidatesTags: ["Cart"],
    }),
}),

// ============================================================
// DEMO: UPDATE PET PAYMENT TYPE
// ============================================================
updatePetPurchaseType: builder.mutation<
    IGetCartResponse,
      {cartItemId:number ,data: IUpdatePetPurchaseTypeRequest}
>({
    query: ({cartItemId,data}) => ({
        url: `${UPDATE_PET_PURCHASE_TYPE}/${cartItemId}/purchase-type`,
        method: "patch",
        data: data,
    }),
    invalidatesTags: ["Cart"],
}),

    IncreaseProductQuantity: builder.mutation<
      CheckoutSummaryResponseDto,
      number
    >({
      query: (cartItemId) => ({
        url: `${PRODUCT_CART_MODIFICATION}/${cartItemId}/increase`,
        method: "patch",
      }),
      invalidatesTags: ["Cart"],
    }),
    DecreaseProductQuantity: builder.mutation<
      CheckoutSummaryResponseDto,
      number
    >({
      query: (cartItemId) => ({
        url: `${PRODUCT_CART_MODIFICATION}/${cartItemId}/decrease`,
        method: "patch",
      }),
      invalidatesTags: ["Cart"],
    }),
    removeProduct: builder.query<CheckoutSummaryResponseDto, number>({
      query: (cartItemId) => ({
        url: `${PRODUCT_CART_MODIFICATION}/${cartItemId}`,
        method: "delete",
      }),
    }),
    removePet: builder.query<CheckoutSummaryResponseDto, number>({
      query: (cartItemId) => ({
        url: `${PET_CART_MODIFICATION}/${cartItemId}`,
        method: "delete",
      }),
    }),

    removeService: builder.query<CheckoutSummaryResponseDto, number>({
      query: (cartItemId) => ({
        url: `${SERVICE_CART_MODIFICATION}/${cartItemId}`,
        method: "delete",
      }),
    }),

    PaymentInitiate: builder.mutation<
      PaymentSessionResponse,
      PaymentInitiateRequest
    >({
      query: (data) => ({
        url: PAYMENT_INITIATE,
        method: "post",
        data: data,
      }),
    }),

    PaymentStatus: builder.query<PaymentStatusResponse, string>({
      query: (transactionReference) => ({
        url: `${PAYMENT_STATUS}/${transactionReference}`,
        method: "get",
      }),
    }),

    getProductsBycategory: builder.query<
      IGetProductsByCategoryResponse,
      IGetProductsByCategoryRequest
    >({
      query: (data) => ({
        url: GetProductsBycategory,
        method: "get",
        data: data,
      }),
    }),
    GetTopUpOffer: builder.query<IWalletTopupPackagesResponse, void>({
      query: () => ({
        url: GET_WALLETS_TOP_UP,
        method: "get",
      }),
    }),
    AddTopupOffer: builder.mutation<
      IWalletPaymentResponse,
      IAddTopUpWalletRequest
    >({
      query: (data) => ({
        url: WALLETS_TOP_UP,
        method: "post",
        data: data,
      }),
    }),

    getCustomerOrders: builder.query<
      IGetCustomerOrdersResponse,
      IGetCustomerOrdersRequest
    >({
      query: (data) => ({
        url: GET_CUSTOMER_ORDERS,
        method: "get",
        params: data,
      }),
    }),

    getCustomerOrderDetails: builder.query<
      IGetCustomerOrderDetailsResponse,
      number
    >({
      query: (orderId) => ({
        url: `${GET_CUSTOMER_ORDER_DETAILS}/${orderId}`,
        method: "get",
      }),
    }),

    reviewRevision: builder.mutation<void, ISubmitReviewRequest>({
      query: (data) => ({
        url: UPDATE_REVISION,
        method: "post",
        data: data,
      }),
    }),

    retryRevision: builder.mutation<
      CreatePaymentSessionResponse,
      IRetryRevisionRequest
    >({
      query: (data) => ({
        url: RETRY_PAYMENT,
        method: "post",
        data: data,
      }),
    }),

    completeInternalPayment: builder.mutation<
      CompleteInternalPaymentResponse,
      {
        orderId: number;
        paymentMethod: string;
      }
    >({
      query: (body) => ({
        url: WALLET_PAYMENT,
        method: "post",
        data: body,
      }),
    }),

        RateOrder: builder.mutation<
      ICustomerRatingResponse,
      {OrderId:number,data:ICustomerRateOrderRequest}
    >({
      query: ({OrderId,data}) => ({
        url: `${GET_CUSTOMER_ORDERS}/${OrderId}/review`,
        method: "post",
        data: data,
      }),
    }),

        rateOrderItems: builder.mutation<
      ICustomerRatingResponse,
       {OrderId:number,data:ICustomerRateOrderItemRequest}
    >({
        query: ({OrderId,data}) => ({
        url: `${GET_CUSTOMER_ORDERS}/${OrderId}/items/review`,
        method: "post",
        data: data,
      }),
    }),



    // ------------------------------------------------------------
    // Get Payment Result
    //
    // Polls the backend after returning from the payment
    // gateway.
    //
    // Poll until:
    //
    // • paymentStatus == "Paid"
    // • isPostProcessed == true
    // ------------------------------------------------------------

    getPaymentResult: builder.query<PaymentResult, string>({
      query: (transactionReference) => ({
        url: PAYMENT_SUCCESS_DETAILS.replace(
          "{transactionReference}",
          transactionReference,
        ),
        method: "get",
      }),
    }),
  }),
});

export const {
  useCreateCartMutation,
  useLazyGetCartQuery,
  useUpdateCartMutation,
  useLazyDeleteCartQuery,
  useLazyGetUserCartQuery,

  useAddPetTocartMutation,
  useLazyRemoveTocartQuery,
  useLazyRemoveServiceTocartQuery,
  useAddBundleToCartMutation,
  useLazyRemoveBundleFromCartQuery,

  useLazyGetCheckoutSummaryQuery,
  useApplyCouponMutation,
  useApplyRewardPointsMutation,
  useSelectFreeGiftMutation,
  useUpdateDonationMutation,
  useApplyWalletMutation,
  useLazyRemoveWalletQuery,
  useLazyRemoveCouponQuery,
  useLazyRemoveFreeGiftQuery,
  useLazyRemoveRewardPointsQuery,
  useSelectAddressMutation,
  useProcessToCheckoutMutation,
  usePaymentInitiateMutation,

  useLazyPaymentStatusQuery,
  useLazyGetProductsBycategoryQuery,

  useIncreaseProductQuantityMutation,
  useDecreaseProductQuantityMutation,
  useLazyRemovePetQuery,
  useLazyRemoveProductQuery,
  useLazyRemoveServiceQuery,

  useLazyGetTopUpOfferQuery,
  useAddTopupOfferMutation,
  useLazyGetCustomerOrdersQuery,
  useLazyGetCustomerOrderDetailsQuery,
  useReviewRevisionMutation,
  useRetryRevisionMutation,
  useAddServiceToCartMutation,
  useCompleteInternalPaymentMutation,
  useLazyGetPaymentResultQuery,


  useRateOrderItemsMutation,
  useRateOrderMutation,
      useUpdateCartSubscriptionMutation,
    useUpdatePetPurchaseTypeMutation,
} = customerCartAPi;
